import { CollectionState, useCollectionContext } from 'components/settings/collectionContext';
import {
    Account,
    ACCOUNT_COLLECTION_NAME,
    UserProfile,
    USER_PROFILE_COLLECTION_NAME,
} from 'models';
import { where } from 'firebase/firestore';
import { useAuthState } from 'firebaseStore';

export const useUserProfile = (): [UserProfile | undefined, boolean] => {
    const [user, userPending] = useAuthState();

    const [profiles, profilesPending] = useCollectionContext(USER_PROFILE_COLLECTION_NAME, [
        where('email', '==', user?.email || ''),
    ]) as CollectionState<UserProfile>;
    if (userPending) {
        return [undefined, userPending];
    }
    if (!user) {
        return [undefined, userPending];
    }
    if (profilesPending) {
        return [undefined, profilesPending];
    }
    if (!profiles.length) {
        return [undefined, profilesPending];
    }
    if (profiles.length > 1) {
        console.error(`Multiple profiles for ${user?.email || ''}`);
        return [undefined, profilesPending];
    }
    return [profiles[0], profilesPending];
};

export const useAccountRecord = (): Account | undefined => {
    const [me, userPending] = useUserProfile();
    const [, , tenant] = useAuthState();
    const [accounts, accountsPending] = useCollectionContext(
        ACCOUNT_COLLECTION_NAME
    ) as CollectionState<Account>;
    if (userPending) {
        return undefined;
    }
    if (!me) {
        return undefined;
    }
    if (accountsPending) {
        return undefined;
    }
    if (accounts.length > 1) {
        return undefined;
    }
    if (accounts.length === 0) {
        return new Account({ tenantId: tenant });
    }
    return accounts[0];
};

export const useAccount = (): Account => {
    return useAccountRecord() as Account;
};
